module.exports = __webpack_public_path__ + "assets/3e2da1fc87191f91dc591566b33a1299.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/pick/FgSelectMystery_Stem_Hit.mp3
 ** module id = 494
 ** module chunks = 0
 **/